import { defineMessages } from 'react-intl';

const messages = defineMessages({
  createReturn: {
    defaultMessage: 'Create Return',
    id: '9rRWSa',
    description: 'Label for the create return button',
  },
});
export default messages;
